import { render, staticRenderFns } from "./News.vue?vue&type=template&id=1b8daf0b&scoped=true"
import script from "./News.vue?vue&type=script&lang=js"
export * from "./News.vue?vue&type=script&lang=js"
import style0 from "./News.vue?vue&type=style&index=0&id=1b8daf0b&prod&lang=stylus&scoped=true"
import style1 from "./News.vue?vue&type=style&index=1&id=1b8daf0b&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b8daf0b",
  null
  
)

export default component.exports